import { Component, Input, OnInit } from '@angular/core';
import { ME_Fit } from 'me-fit-typings';
import { fadeInOut } from 'src/app/animations';
import { Feedback } from 'src/app/decorators/feedback-decorator';
import { CustomersStateService } from 'src/app/state/customers.state.service';

@Component({
  selector: 'me-customer-ion-item',
  templateUrl: './customer-ion-item.component.html',
  styleUrls: ['./customer-ion-item.component.scss'],
  animations: [fadeInOut]
})
export class CustomerIonItemComponent implements OnInit {

  @Input() customer: ME_Fit.OrganizationCustomer | null | undefined;

  @Input({
    required: false
  }) customerId: string;

  @Input() routerLink: string | any[];

  @Input() queryParams: Record<string, string> | undefined;

  @Input() details = false;

  get showButton() {
    return this.routerLink || this.details;
  }

  constructor(private $customerState: CustomersStateService) { }

  ngOnInit(): void {
    if (this.customerId) {
      this.loadCustomerDetails(this.customerId);
    }
  }

  @Feedback({
    i18nFailKey: 'customer.detail.customer.data.load.error',
    showLoader: false
  })
  async loadCustomerDetails(customerId: string) {
    const promise = this.$customerState.get.callWithoutStateMutation({
      pathParts: {
        customerId: customerId
      },
      getLastResponse: true
    });

    try {
      this.customer = await promise;
    } catch {}

    return promise;
  }
}
